<template>
<div class="videos_inner dirr">
    <div class="title">
        <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
        <router-link :to="'/media/?lang='+$i18n.locale" class="tl">{{ $t("index_videos") }}</router-link>
    </div>
    <!-- <div class="search">
        <v-form class="form" ref="form" v-model="valid">
            <v-text-field @input="preSearch()" @keyup.enter.native="search()" onkeypress="return event.keyCode != 13" v-model="i.Squery" solo class="dirr" full-width :label="$t('search')" :rules="[rules.required]"></v-text-field>
            <v-btn height="56" :class="'tl btn ' + $store.state.direction" :loading="loading" color="#FFFFFF" @click="search()">
                <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <rect width="28" height="28" fill="url(#pattern0)" fill-opacity="0.5"/>
                    <defs>
                    <pattern id="pattern0" patternContentUnits="objectBoundingBox" width="1" height="1">
                    <use xlink:href="#image0_2340_1929" transform="scale(0.0078125)"/>
                    </pattern>
                    <image id="image0_2340_1929" width="128" height="128" xlink:href="data:image/png;base64,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"/>
                    </defs>
                </svg>
            </v-btn>
        </v-form>
    </div> -->
    <div class="videoCon">
        <v-layout row v-if="skeleton">
            <v-flex xs12 sm8 md8 lg8 style="padding:0 10px;">
                <v-skeleton-loader  width="800" min-width="800" type="image"></v-skeleton-loader>
                <v-skeleton-loader  width="800" min-width="800" type="card"></v-skeleton-loader>
                <v-skeleton-loader  width="800" min-width="800" type="paragraph, paragraph, paragraph, sentences, paragraph, sentences paragraph, sentences paragraph, sentences"></v-skeleton-loader>
            </v-flex>
            <v-flex xs12 sm4 md4 lg4 style="padding:0 10px;">
                <v-skeleton-loader v-for="i in 6" :key="i" height="100" style="margin-bottom:30px;" width="300" min-width="300" type="card"></v-skeleton-loader>
            </v-flex>
        </v-layout>
        <v-layout row v-if="!skeleton">
            <v-flex xs12 sm7 md8 lg8 style="padding:0 10px;">
                <p class="tl ta title1">{{videoRes.title}}</p>
                <div class="details">
                    <div class="division" v-if="videoRes.cat_title">
                        <span>
                        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M10.1265 0.680164L6.0592 4.77808L6.73634 5.46032L10.8036 1.36241L10.1265 0.680164Z" fill="#B1BD52"/>
                            <path d="M10.1302 3.40876L7.41504 6.14441L8.09218 6.82665L10.8074 4.091L10.1302 3.40876Z" fill="#B1BD52"/>
                            <path d="M14.1926 4.7787L13.5155 5.46094L14.1926 6.14318L14.8698 5.46094L14.1926 4.7787Z" fill="#B1BD52"/>
                            <path d="M11.4843 4.77402L8.77136 7.50745L9.4485 8.18969L12.1615 5.45626L11.4843 4.77402Z" fill="#B1BD52"/>
                            <path d="M11.4855 7.5066L10.1268 8.87555L10.804 9.55779L12.1627 8.18885L11.4855 7.5066Z" fill="#B1BD52"/>
                            <path d="M10.1303 3.41039L13.516 6.82159L14.1931 6.13935L10.8074 2.72815L10.1303 3.41039Z" fill="#B1BD52"/>
                            <path d="M12.7116 3.28386L14.8713 5.4599L15.5485 4.77766L13.3887 2.60162L12.7116 3.28386Z" fill="#B1BD52"/>
                            <path d="M10.1306 6.14035L12.162 8.18707L12.8391 7.50483L10.8077 5.4581L10.1306 6.14035Z" fill="#B1BD52"/>
                            <path d="M6.06551 4.77829L8.09692 6.82501L8.77406 6.14277L6.74265 4.09604L6.06551 4.77829Z" fill="#B1BD52"/>
                            <path d="M10.1302 0.682227L12.0355 2.60187L12.7127 1.91962L10.8074 -1.60074e-05L10.1302 0.682227Z" fill="#B1BD52"/>
                            <path d="M1.31787 10.922L5.38513 15.02L6.06227 14.3377L1.99501 10.2398L1.31787 10.922Z" fill="#B1BD52"/>
                            <path d="M4.02626 10.9169L6.74146 13.6525L7.4186 12.9703L4.7034 10.2346L4.02626 10.9169Z" fill="#B1BD52"/>
                            <path d="M5.38695 6.82478L6.06409 7.50702L6.74122 6.82478L6.06409 6.14254L5.38695 6.82478Z" fill="#B1BD52"/>
                            <path d="M5.38443 9.55051L8.09741 12.2839L8.77455 11.6017L6.06157 8.86827L5.38443 9.55051Z" fill="#B1BD52"/>
                            <path d="M8.09406 9.55098L9.45276 10.9199L10.1299 10.2377L8.77119 8.86874L8.09406 9.55098Z" fill="#B1BD52"/>
                            <path d="M4.02739 10.9174L7.41309 7.50623L6.73595 6.82398L3.35025 10.2352L4.02739 10.9174Z" fill="#B1BD52"/>
                            <path d="M3.90481 8.31648L6.06458 6.14044L5.38744 5.4582L3.22768 7.63424L3.90481 8.31648Z" fill="#B1BD52"/>
                            <path d="M6.73763 10.9159L8.76904 8.86914L8.09191 8.1869L6.06049 10.2336L6.73763 10.9159Z" fill="#B1BD52"/>
                            <path d="M5.38525 15.0154L7.29053 13.0958L6.61339 12.4135L4.70811 14.3332L5.38525 15.0154Z" fill="#B1BD52"/>
                            <path d="M1.32104 10.9203L3.22632 9.00067L2.54918 8.31843L0.643898 10.2381L1.32104 10.9203Z" fill="#B1BD52"/>
                            <path d="M11.483 19.8005L15.5503 15.7026L14.8732 15.0203L10.8059 19.1182L11.483 19.8005Z" fill="#B1BD52"/>
                            <path d="M11.4801 17.0709L14.1953 14.3353L13.5182 13.653L10.803 16.3887L11.4801 17.0709Z" fill="#B1BD52"/>
                            <path d="M7.41979 15.7016L8.09692 15.0193L7.41979 14.3371L6.74265 15.0193L7.41979 15.7016Z" fill="#B1BD52"/>
                            <path d="M10.125 15.7044L12.838 12.971L12.1609 12.2888L9.44789 15.0222L10.125 15.7044Z" fill="#B1BD52"/>
                            <path d="M10.1259 12.9753L11.4846 11.6064L10.8075 10.9241L9.44878 12.2931L10.1259 12.9753Z" fill="#B1BD52"/>
                            <path d="M11.4802 17.0687L8.09448 13.6575L7.41734 14.3397L10.803 17.7509L11.4802 17.0687Z" fill="#B1BD52"/>
                            <path d="M8.89975 17.1965L6.73999 15.0204L6.06285 15.7027L8.22261 17.8787L8.89975 17.1965Z" fill="#B1BD52"/>
                            <path d="M11.4783 14.3398L9.4469 12.2931L8.76976 12.9753L10.8012 15.0221L11.4783 14.3398Z" fill="#B1BD52"/>
                            <path d="M15.5472 15.7023L13.642 13.7827L12.9648 14.4649L14.8701 16.3845L15.5472 15.7023Z" fill="#B1BD52"/>
                            <path d="M11.4821 19.7978L9.57678 17.8781L8.89964 18.5604L10.8049 20.48L11.4821 19.7978Z" fill="#B1BD52"/>
                            <path d="M20.2944 9.55848L16.2272 5.46057L15.55 6.14281L19.6173 10.2407L20.2944 9.55848Z" fill="#B1BD52"/>
                            <path d="M17.5851 9.56445L14.8699 6.8288L14.1927 7.51104L16.9079 10.2467L17.5851 9.56445Z" fill="#B1BD52"/>
                            <path d="M16.225 13.654L15.5479 12.9717L14.8707 13.654L15.5479 14.3362L16.225 13.654Z" fill="#B1BD52"/>
                            <path d="M16.2295 10.9256L13.5165 8.1922L12.8393 8.87444L15.5523 11.6079L16.2295 10.9256Z" fill="#B1BD52"/>
                            <path d="M13.5184 10.9259L12.1597 9.55695L11.4825 10.2392L12.8412 11.6081L13.5184 10.9259Z" fill="#B1BD52"/>
                            <path d="M17.5839 9.56291L14.1982 12.9741L14.8754 13.6564L18.2611 10.2452L17.5839 9.56291Z" fill="#B1BD52"/>
                            <path d="M17.7096 12.1625L15.5498 14.3386L16.2269 15.0208L18.3867 12.8448L17.7096 12.1625Z" fill="#B1BD52"/>
                            <path d="M14.8758 9.56345L12.8444 11.6102L13.5215 12.2924L15.5529 10.2457L14.8758 9.56345Z" fill="#B1BD52"/>
                            <path d="M16.2256 5.4658L14.3203 7.38544L14.9975 8.06768L16.9027 6.14804L16.2256 5.4658Z" fill="#B1BD52"/>
                            <path d="M20.2918 9.56125L18.3865 11.4809L19.0636 12.1631L20.9689 10.2435L20.2918 9.56125Z" fill="#B1BD52"/>
                            <path d="M11.4833 7.50884L10.8062 6.8266L9.45409 8.18885L10.1312 8.87109L11.4833 7.50884Z" fill="white"/>
                            <path d="M12.1443 12.2759L11.4672 11.5936L10.1151 12.9559L10.7922 13.6381L12.1443 12.2759Z" fill="white"/>
                            <path d="M9.45221 10.9194L8.09351 9.55048L7.41637 10.2327L8.77507 11.6017L9.45221 10.9194Z" fill="white"/>
                            <path d="M14.1972 10.2437L12.8385 8.87476L12.1614 9.557L13.5201 10.9259L14.1972 10.2437Z" fill="white"/>
                        </svg>
                        </span>
                        <!-- <p class="tl">{{ videoRes.cat_title }}</p> -->
                        <router-link :to="'/mediacat/' + videoRes.cat + '?&lang=' +$i18n.locale" class="tl" >{{ videoRes.cat_title }}</router-link>
                    </div>
                    <span></span>
                    <div class="date">
                        <span><img :src="$vuetify.theme.dark ? '/assets/img/date_big_white.svg' : '/assets/img/date_big_dark.svg'" /></span>
                        <p class="tl d-none d-sm-flex" v-html="replaceSpace(videoRes.date)"></p>
                        <p class="tl d-flex d-sm-none" v-html="replaceSpace(videoRes.date)"></p>
                    </div>
                    <span></span>
                    <div class="views">
                        <span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#B1BD52" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>
                        </span>
                        <!-- <p class="tl">{{ $t("views_count") + ' ' + numFormatter(videoRes.views) }}</p> -->
                        <p class="tl">{{ numFormatter(videoRes.views) }}</p>
                    </div>
                    <span></span>
                    <div class="download">
                        <span>
                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.92026 1.08629C7.92885 0.517269 8.39045 0.0155458 8.9114 0.00447207C9.63699 -0.00149069 10.3634 -0.00149069 11.0889 0.00447207C11.6107 0.0146939 12.0707 0.518121 12.0801 1.08714C12.0871 2.8453 12.0809 4.60346 12.0832 6.36162C12.876 6.36843 13.6703 6.34799 14.463 6.37099C14.952 6.41358 15.1816 7.15892 14.8192 7.51924C13.3696 9.1803 11.9161 10.8379 10.4641 12.4964C10.2306 12.792 9.77132 12.7937 9.53858 12.4981C8.07569 10.8243 6.60656 9.1573 5.14992 7.47836C4.82188 7.10526 5.0765 6.39995 5.54903 6.37014C6.33788 6.34969 7.12751 6.36758 7.91714 6.36162C7.91948 4.60346 7.91323 2.84445 7.92026 1.08629Z" fill="#B1BD52"/>
                            <path d="M1.05641 14.6024C1.22043 14.5487 1.39303 14.5393 1.5633 14.5385C7.05792 14.5402 12.5525 14.5385 18.0472 14.5393C18.3814 14.5444 18.7306 14.5044 19.0492 14.6407C19.5874 14.8528 19.9802 15.4397 19.9935 16.0649C20.0029 16.4721 20.0263 16.904 19.8498 17.2771C19.6124 17.8248 19.0695 18.1885 18.5134 18.1732C12.8368 18.174 7.16024 18.174 1.48285 18.1732C0.910352 18.1885 0.35347 17.7984 0.127749 17.2251C-0.0276777 16.8622 -0.00112199 16.4517 0.00668841 16.0624C0.0191851 15.3946 0.469065 14.7804 1.05641 14.6024Z" fill="#B1BD52"/>
                            </svg>
                        </span>
                        <a :href="this.Url+'videos/saveVid/'+videoRes.request" class="tl" target="_blank">{{ $t("download") }}</a>
                    </div>
                </div>
                <div class="media">
                    <div class="vid">
                        <div class="vidCon">
                            <video ref="videoPlayer" class="video-js vjs-theme-fantasy" :poster="'https://alkafeel.net/videos/mcroped/765/'+videoRes.photo" preload="auto" width="800" height="500">
                                <track v-for="(i,x) in CapData" :key="x" :src="'https://alkafeel.net/videos/upload/vtt/'+i" kind="captions" :srclang="x" :label="x" :default="Capdefault(x)">
                                <!-- <track v-if="CapFile" :src="CapFile" kind="captions" srclang="en" label="ar"> -->
                            </video>
                        </div>
                    </div>
                </div>
                <p :class="$i18n.locale=='ar' ? 'txx' : 'tx'" class="ta" v-html="bbcode(videoRes.caption)" v-if="videoRes.caption"></p>
                <div class="comments">
                    <div class="readers" v-if="showcomments">
                        <div class="title">
                            <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                            <p class="tl">{{ $t("news_add-comment") }}</p>
                        </div>
                        <div class="items">
                            <div class="item_con" style="margin:35px 0" v-for="i in commentsres" :key="i">
                                <div class="item">
                                    <div class="imgt">
                                        <!-- <img src="https://alkafeel.net/news/mcroped96/625/c79e2ff582bd0b443650ae8e4fd2bc87.JPG" :alt="i.name" /> -->
                                        <div class="img">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 144.1 192" fill="#605c5c" xmlns:v="https://vecta.io/nano"><path d="M56.8 1.9C64.2-.5 72.2 0 79.9.3c17 1.4 31.6 16.6 32.1 33.7.1 11 .4 22-.1 33-.7 11.4-6.8 22.1-15.8 28.9.2 3 0 6.1.1 9.1.4 1.1 1.9 1.3 2.8 1.9l33.7 16.8c6.8 3.3 11.7 10.6 11.5 18.3l-.1 46.9c-.7 4.5-8.1 3.6-7.9-.9l-.1-47.1c-.2-4.2-2.9-8-6.7-9.8l-34-17c-1.6 6.2-5.8 11.5-11.3 14.8.3 7.7.1 15.4 0 23.1.2 6.4-5.5 12.2-11.9 12-6.4.3-12.2-5.5-12-11.9 0-7.7-.2-15.4.1-23.1-5.5-3.3-9.5-8.7-11.5-14.9-11.3 5.9-22.9 11.4-34.2 17.2-3.9 2-6.5 6.3-6.2 10.7l-.1 46.2c.1 4.5-7.3 5.2-7.9.8-.3-12.3-.2-24.6-.1-36.9 0-5-.6-10 .5-15 1.4-5.9 5.8-10.9 11.3-13.5l36.1-17.9c.2-3.3 0-6.5 0-9.7-9.2-7.1-15.4-18.2-15.8-29.9-.1-6-.3-12-.1-18 .1-7.7-.8-15.5 1.7-22.9C37.2 14.3 46 5.4 56.8 1.9zm2.1 7.7c-9.7 3.3-17.2 12.3-18.5 22.5h63.4c-1.7-13-13.5-23.9-26.7-23.9-6 .1-12.4-.8-18.2 1.4zM40.1 40.1l.1 27c.6 8.1 4.7 15.8 10.8 21.1 9.3 8.4 23.7 10.2 34.8 4.8 10.2-4.8 17.6-15.4 18-26.8.4-8.7.2-17.3 0-26l-63.7-.1zm16 60.6c.2 5.8-.8 12.3 3.2 17 5.7 8.1 18.9 8.4 25 .6 4.4-4.8 3.7-11.7 3.8-17.7-10 4.5-21.9 4.6-32 .1zM68 131.8l.2 21.2c.6 3.9 7.2 4 7.7 0 .3-7.1.3-14.1.3-21.2-2.8.2-5.5.2-8.2 0zm-37.6 24.6c2.5-1.2 5.6.8 5.8 3.5-.2 7.1 0 14.1-.2 21.1-.2 3.1.9 6.6-.7 9.5-2 2.9-7.5 1.4-7.2-2.4l-.2-25.1c.1-2.3-.1-5.5 2.5-6.6zm80 0c2.1-1 5.1.3 5.5 2.7.7 6.6-.1 13.3.1 19.9-.1 3.6.5 7.2-.3 10.7-1.2 3-6 3-7.3 0-1-3.2-.2-6.5-.3-9.7-.2-6 .1-12 0-18 0-2.1 0-4.8 2.3-5.6z"/></svg>
                                        </div>
                                        <p class="tl">{{i.name}}</p>
                                    </div>
                                    <p class="tl ta">{{i.post}}</p>
                                </div>
                            </div>
                            <v-btn v-if="getMorecomments" width="150" height="40" class="ma-2 tl" style="align-self:center;" :loading="loading1" color="rgba(177, 189, 82, 1)" @click="getcomments()">
                                <p class="alistSub tl">{{ $t('view_more') }}</p>
                            </v-btn>
                            <p class="no_comment" v-if="!getMorecomments">{{ $t('no_more_comment') }}</p>
                        </div>
                    </div>
                    <div class="add">
                        <div class="title">
                            <span><img :src="$vuetify.theme.dark ? '/assets/img/z-mohammed_dark.svg' : '/assets/img/z-mohammed.svg'" /></span>
                            <p class="tl">{{ $t("add_comment") }}</p>
                        </div>
                        <v-form class="commentsForm" ref="form" v-model="valid">
                            <div class="F_Cont">
                                <v-text-field @keyup.enter.native="comment_send()" v-model="comments.name" background-color="rgba(255, 255, 255, 0.4)" :rules="[rules.required]" :placeholder="$t('name')" outlined></v-text-field>
                                <div style="margin:0 10px;" class="d-none d-sm-flex"></div>

                                <!-- <v-text-field @keyup.enter.native="comment_send()" v-model="comments.mail" background-color="rgba(255, 255, 255, 0.4)" :rules="[rules.email]" :placeholder="$t('msg_email_optional')" outlined></v-text-field> -->



                            </div>
                            <v-textarea v-model="comments.post" style="width:100%;" background-color="rgba(255, 255, 255, 0.4)" :rules="[rules.required]" :placeholder="$t('Comment_text')" outlined></v-textarea>
                            <v-btn width="150" height="40" class="ma-2 tl" :loading="loading2" color="rgba(177, 189, 82, 1)" @click="comment_send()">
                                <p class="alistSub tl">{{ $t('action_send') }}</p>
                            </v-btn>
                        </v-form>
                    </div>
                </div>
            </v-flex>
            <v-flex xs12 sm5 md4 lg4 style="padding:0 10px;">
                <div class="related">
                    <router-link v-for="i in relatedVideos" :key="i" :to="'/media/' + i.request + '?lang=' +$i18n.locale">
                        <div class="img">
                            <v-img :lazy-src="'https://alkafeel.net/videos/mcroped/100/'+i.photo"
                                :src="'https://alkafeel.net/videos/mcroped/360/'+i.photo" style="border-radius: 4px; width: 100%; height: 100%;">
                            </v-img>
                            <div class="bkg"></div>
                            <div class="icon">
                                <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="18" cy="18" r="18" fill="#B1BD52" fill-opacity="0.8"/>
                                <path d="M25.5 17.134C26.1667 17.5189 26.1667 18.4811 25.5 18.866L15 24.9282C14.3333 25.3131 13.5 24.832 13.5 24.0622L13.5 11.9378C13.5 11.168 14.3333 10.6869 15 11.0718L25.5 17.134Z" fill="white"/>
                                </svg>
                            </div>
                            <div class="duration" v-if="i.length" v-html="formatLength(i.length)"></div>
                        </div>
                        <div class="paregs">
                            <p class="tl ta">{{i.title|subStrTitle2}}</p>
                            <div class="date">
                                <span><img :src="$vuetify.theme.dark ? '/assets/img/date_mini_white.svg' : '/assets/img/date_mini_dark.svg'" /></span>
                                <p class="tl" v-html="TimeSince(i.time)"></p>
                            </div>
                        </div>
                    </router-link>
                </div>
            </v-flex>
        </v-layout>
    </div>
</div>
</template>

<script>
import Axios from "axios";
import videojs from 'video.js';
import 'video.js/dist/video-js.min.css';
import '@videojs/themes/dist/fantasy/index.css';
import bbCodeParser from 'js-bbcode-parser';
require('@silvermine/videojs-quality-selector')(videojs);
require('@silvermine/videojs-quality-selector/dist/css/quality-selector.css');
import Swal from "sweetalert2";
export default {
    name: "VideoPlayer",
    data() {
        return {
            videoRes : [],
            relatedVideos : [],
            //video_id : this.$route.query.key,
            video_id : this.$route.params.id,
            player: null,
            skeleton : true,
            commentsres : [],
            CapData : '',
            commentsPage : 1,
            getMorecomments : true,
            showcomments : true,
            loader: null,
            loading1: false,
            loading2: false,
            comments:{name:'', mail:'', post:'', req:''},
            videoOptions: {
                autoplay: true,
                controls: true,
                controlBar: {
                    children: [
                        'playToggle',
                        'progressControl',
                        'volumePanel',
                        'qualitySelector',
                        'fullscreenToggle',
                        'CaptionsButton',
                    ],
                },
                // fill: true,
                // fluid: false,
                sources: [],
            },
            valid: false,
            rules: {
                required: value => !!value || this.$t("required_field"),
                email: v => !v || /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || this.$t("alert_wrong_email"),
            },
        }
    },
    watch: {
        '$route' () {
            const state = { 'page_id': 1 };
            const url = '/media/'+this.$route.params.id+'?lang='+this.$i18n.locale;
            history.pushState(state, '', url);
            this.video_id =  this.$route.params.id;
            document.title =this.$t("index_videos");
            window.scrollTo(0, 0);
            this.getvideos();
            setTimeout(() => {
                // this.player.src([{ type: "video/mp4", src: "application/x-mpegURL", src: "https://static1.alkafeel.net/videos/"+this.videoRes[0]['video']+"/"+this.videoRes[0]['video']+".m3u8" },]);
                this.player.src(this.SRCs(this.videoRes['request']));
                this.player.poster('https://alkafeel.net/videos/mcroped/765/'+this.videoRes.photo);
                this.$refs.videoPlayer.load();
                this.play_player();
            }
            , 500);
        },
        loader () {
            const l = this.loader
            this[l] = !this[l]
            setTimeout(() => (this[l] = false), 2000)
            this.loader = null
        },
    },
    components: {
    },
    directives: {
    },
    computed: {
    },
    mounted() {
        document.title =this.$t("index_videos");  
    }, 
    created () {
        this.getvideos ();
    },
    methods:{
        getvideos () {

            if (this.checkCookie('videos', this.video_id)) {
                
                // console.log('Passed');

                Axios.get("videos/ByReq/" + this.video_id, {})
                .then(res => {
                    if (res.data.length === 0) {
                        this.$router.push('/media?lang=' + this.$i18n.locale)
                    }
                    else {
                        this.videoRes = res.data;
                        setTimeout(() => this.skeleton = false, 500);
                        this.CapData = JSON.parse(res.data['captions_files']);
                        // if (Object.keys(this.CapData)[0] == this.$i18n.locale) {
                        //     this.CapFile = 'https://alkafeel.net/videos/upload/vtt/'+this.CapData[Object.keys(this.CapData)[0]];
                        // }
                        this.videoOptions.sources = this.SRCs (res.data['request'],res.data['res']);
                        //this.videoOptions.sources[0].src = "https://static1.alkafeel.net/videos/"+res.data[0]['video']+"/"+res.data[0]['video']+".m3u8";
                        setTimeout(() => this.play_player(), 500);
                        this.getrelated(res.data['cat'],res.data['request']);
                        this.getcomments();
                    }
                })

            } else {
                this.setCookie('videos', this.video_id);

                // console.log('setCookie');

                Axios.post("videos/stat/"+this.video_id, {req:this.video_id})
                .then(res => {
                    if (res.data.length === 0) {
                        this.$router.push('/media?lang=' + this.$i18n.locale)
                    }
                    else {
                        this.videoRes = res.data;
                        setTimeout(() => this.skeleton = false, 500);
                        this.CapData = JSON.parse(res.data['captions_files']);
                        this.videoOptions.sources = this.SRCs (res.data['request'],res.data['res']);
                        setTimeout(() => this.play_player(), 500);
                        this.getrelated(res.data['cat'],res.data['request']);
                        this.getcomments();
                    }
                })
            }
        },
        getrelated (x,y) {
            Axios.get("videos/relByCat/"+x+"/"+y+"/6", {
            })
            .then(res => {
                this.relatedVideos = res.data;
                //console.log(res.data);
            })
            .catch(() => {
            });
        },
        play_player () {
            this.player = videojs(this.$refs.videoPlayer, this.videoOptions, function onPlayerReady() {
                console.log('asfasd');
            });
            //console.log(this.player.currentSrc());
        },
        SRCs (x,y) {
            if (this.videoRes.id > 16154) {
                if (y > 1080 && y < 2160) {
                    var maxP = [{
                        type: "video/mp4", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/"+x+".mp4" ,
                        label: '1440P',
                    }];
                } else if (y > 2159) {
                    var maxP = [{
                        type: "video/mp4", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/"+x+".mp4" ,
                        label: '2160P',
                    }];
                } else {var maxP = [];}
            } else {
                if (y > 720) {
                    var maxP = [{
                        type: "video/mp4", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/"+x+".mp4" ,
                        label: '1080P',
                    }];
                }  else {var maxP = [];}
            }
            if (this.videoRes.id > 16154) {
                var otherP =  [
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/1080/"+x+"-1080.m3u8" ,
                        label: '1080P',
                    },
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/720/"+x+"-720.m3u8" ,
                        label: '720P',
                    },
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/360/"+x+"-360.m3u8" ,
                        label: '360P',
                    },
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/"+x+".m3u8" ,
                        label: 'AUTO',
                        selected: true,
                    },
                ];
            } else {
                var otherP =  [
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/720/"+x+"-720.m3u8" ,
                        label: '720P',
                    },
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/360/"+x+"-360.m3u8" ,
                        label: '360P',
                    },
                    {
                        type: "application/x-mpegURL", 
                        src: "https://static1.alkafeel.net/videos/"+x+"/"+x+".m3u8" ,
                        label: 'AUTO',
                        selected: true,
                    },
                ];
            }
            
            return  [...maxP, ...otherP ];
        },
        Capdefault (x) {
            if (this.$i18n.locale == x) {return true;}
            else {return null;}
        },
        getcomments () {
            this.loader = 'loading1';
            Axios.get("videos/getComments/" + this.video_id + '/4?page=' + this.commentsPage, {})
            .then(res => {
                this.commentsres = this.commentsres.concat(res.data.data);
                if (res.data.data.length == 0 && this.commentsPage == 1) {this.showcomments = false;}
                if (res.data.data.length < 4) {this.getMorecomments = false;}
                this.commentsPage ++ ;
                //console.log(res.data.data);
            })
            .catch(() => {
            });
        },
        comment_send () {
            if (this.$refs.form.validate()) {
                var query;
                if (this.comments.mail == '') {
                    query = {
                        name: this.comments.name,
                        post: this.comments.post,
                        req: this.video_id,
                    }
                }
                else {
                    query = {
                        name: this.comments.name,
                        post: this.comments.post,
                        req: this.video_id,
                        mail: this.comments.mail
                    }
                }
                Axios.post('videos/postComment', query).then(
                    Swal.fire({
                        title: this.$t("msg_message_sent"),
                        text: "",
                        icon: "success",
                        timer: 3000,
                        confirmButtonColor: '#B1BD52',
                    }),
                    this.comments = {}
                ).catch(() => {});
            }
        },
        bbcode (x) {
            if (x != null) {return bbCodeParser.parse(x);}
        },
        formatLength (i) {
            var Length = i.split(".");
            if (Length[0].substring(0,3) == '00:') {return Length[0].substring(3);}
            else {return Length[0];}
        },
        replaceSpace (i) {
            //return i.replaceAll(' ', '');
            if (i != null)  {return i.replaceAll(' ', '');}
        },
        TimeSince: function (date) {
            date =date*1000;
            var seconds = Math.floor((new Date() - date) / 1000);
            var interval = seconds / 31536000;
            if (this.$i18n.locale === 'tr' || this.$i18n.locale === 'pr') {
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_year") +' '+ this.$t("time_before");}
                interval = seconds / 2592000;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_month") +' '+ this.$t("time_before");}
                interval = seconds / 86400;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("one_day") +' '+ this.$t("time_before");}
                interval = seconds / 3600;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_hour") +' '+ this.$t("time_before");}
                interval = seconds / 60;
                if (interval > 1) {return Math.floor(interval) +' '+ this.$t("time_min") +' '+ this.$t("time_before");}
                return Math.floor(seconds) +' '+ this.$t("time_sec") +' '+ this.$t("time_before");
            } else {
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_year");}
                interval = seconds / 2592000;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_month");}
                interval = seconds / 86400;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("one_day");}
                interval = seconds / 3600;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_hour");}
                interval = seconds / 60;
                if (interval > 1) {return this.$t("time_before") +' '+ Math.floor(interval) +' '+ this.$t("time_min");}
                return this.$t("time_before") +' '+ Math.floor(seconds) +' '+ this.$t("time_sec");
            }
        },
        numFormatter(i) {
            return (Math.abs(i) > 999 ? Math.sign(i)*((Math.abs(i)/1000).toFixed(1)) + 'K' : Math.sign(i)*Math.abs(i)) + ' ' + this.$t('photo_views');
        },



        setCookie(cname, cvalue) {
            const d = new Date();
            d.setTime(d.getTime() + (1*24*60*60*1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        },
        getCookie(cname) {
            let name = cname + "=";
            let ca = document.cookie.split(';');
            for(let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) == ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        checkCookie(cname, id) {
            let username = this.getCookie(cname);
            if (username != "") {
                if (id === username) {
                    return true
                } else {
                    return false
                }
            }
        }
    },
    filters: {
        subStrTitle: function (string) {if (string != null) {return string.substring(0, 60) + '...';}},
        subStrTitle2: function (string) {if (string != null) {return string.substring(0, 40) + '...';}},
    },
}
</script>

